import { useCallback, useEffect, useState } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';

const useMyUsers = () => {
  const [openCloseDrawer, setOpenCloseDrawer] = useState(false);
  const [subAccounts, setSubAccounts] = useState<any[]>([]);
  const [paginatedData, setPaginatedData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });

  const handleOpenCloseDrawer = () => {
    setOpenCloseDrawer(!openCloseDrawer);
  };

  const fetchSubAccounts = useCallback(async () => {
    setLoading(true);
    try {
      const http = initializeHttpProvider();
      const response = await http.userData.getSubAccounts();

      if (response?.success) {
        const data = response.data || [];

        if (Array.isArray(data) && data.length > 0) {
          const transformedData = data.map((user: any, index: number) => ({
            id: user.userCode || `user_${index}`,
            userAccount: user.email,
            name: `${user.firstName || ''} ${user.lastName || ''}`.trim(),
            email: user.email,
            phone: user.phone,
            status: user.active === true ? 'Activo' : 'Inactivo',
            organization: user.organization?.name || '-',
            organizationType: user.organization?.type || 'secondary',
            userCode: user.userCode,
            firstName: user.firstName,
            lastName: user.lastName,
            active: user.active,
            credentials: user.credentials,
          }));

          setSubAccounts(transformedData);
        } else {
          setSubAccounts([]);
        }
      } else {
        setSubAccounts([]);
      }
    } catch (error) {
      console.error('Error fetching sub-accounts:', error);
      setSubAccounts([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSubAccounts();
  }, [fetchSubAccounts]);

  useEffect(() => {
    const start = paginationModel.page * paginationModel.pageSize;
    const end = start + paginationModel.pageSize;
    setPaginatedData(subAccounts.slice(start, end));
  }, [subAccounts, paginationModel]);

  const handlePaginationChange = useCallback((model: { page: number; pageSize: number }) => {
    setPaginationModel(model);
  }, []);

  const handleUserCreated = useCallback(() => {
    handleOpenCloseDrawer();

    setTimeout(() => {
      fetchSubAccounts();
    }, 1000);
  }, [handleOpenCloseDrawer, fetchSubAccounts]);

  return {
    openCloseDrawer,
    handleOpenCloseDrawer,
    handleUserCreated,
    subAccounts,
    paginatedData,
    totalUsers: subAccounts.length,
    loading,
    refreshUsers: fetchSubAccounts,
    handlePaginationChange,
  };
};

export default useMyUsers;
